var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "lesson",
        _vm.lesson.user_state,
        {
          "has-practice": _vm.hasPractice,
          "is-recommended": _vm.isRecommended,
          mobile: _vm.isMobile(_vm.$mq)
        }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "main-lesson" },
        [
          _c("LessonButton", {
            attrs: {
              link: _vm.lessonLinkWithLLP(_vm.lesson.link, _vm.learningPath),
              "is-locked": _vm.isLocked,
              "completion-status": _vm.lesson.user_state,
              "is-recommended": _vm.isRecommended,
              "is-last": _vm.isLast,
              "practice-lessons": _vm.lesson.practice_lessons.length,
              "tracking-payload": {
                axId: _vm.user.is_in_nux
                  ? "clicked_nux_start_lesson"
                  : "clicked_course_landing_lesson",
                axType: "button",
                axExtra: {
                  course_id: _vm.courseId,
                  lesson_id: _vm.lesson.quiz_id,
                  locked: _vm.isLocked
                }
              },
              "course-name": _vm.courseName
            },
            on: { "access-prevented": _vm.preventAccess }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "title-container" },
            [
              _c(
                "router-link",
                {
                  attrs: {
                    to: _vm.lessonLinkWithLLP(_vm.lesson.link, _vm.learningPath)
                  }
                },
                [
                  _c(
                    "h4",
                    {
                      directives: [
                        {
                          name: "track",
                          rawName: "v-track:click",
                          value: {
                            axId: _vm.user.is_in_nux
                              ? "clicked_nux_start_lesson"
                              : "clicked_course_landing_lesson",
                            axType: "button",
                            axExtra: {
                              course_id: _vm.courseId,
                              lesson_id: _vm.lesson.quiz_id,
                              locked: _vm.isLocked
                            }
                          },
                          expression:
                            "{\n            axId: user.is_in_nux ? 'clicked_nux_start_lesson' : 'clicked_course_landing_lesson',\n            axType: 'button',\n            axExtra: {\n              course_id: courseId,\n              lesson_id: lesson.quiz_id,\n              locked: isLocked,\n            },\n          }",
                          arg: "click"
                        }
                      ],
                      staticClass: "title",
                      on: { click: _vm.preventIfLocked }
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(_vm.lesson.name) + "\n        "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              !_vm.isLocked &&
              _vm.lesson.user_state === "started" &&
              _vm.completionPercentage
                ? _c(
                    "div",
                    { staticClass: "progress-bar-container" },
                    [
                      _c("ProgressBar", {
                        attrs: {
                          "completion-percentage": _vm.completionPercentage
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isMobile(_vm.$mq)
                ? _c("LessonAdmin", {
                    staticClass: "lesson-admin main",
                    attrs: { lesson: _vm.lesson }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.lesson.practice_lessons.length
        ? _c(
            "div",
            { staticClass: "practice-lessons" },
            _vm._l(_vm.lesson.practice_lessons, function(practiceLesson) {
              return _c(
                "div",
                { key: practiceLesson.slug, staticClass: "practice-lesson" },
                [
                  _c("LessonButton", {
                    attrs: {
                      link: _vm.lessonLinkWithLLP(
                        practiceLesson.link,
                        _vm.learningPath
                      ),
                      "is-locked": _vm.isLocked,
                      "completion-status": practiceLesson.user_state,
                      "is-highlighted": _vm.lesson.user_state === "completed",
                      "tracking-payload": {
                        axId: "clicked_course_landing_practice",
                        axType: "button",
                        axExtra: {
                          course_id: _vm.courseId,
                          lesson_id: practiceLesson.quiz_id,
                          locked: _vm.isLocked
                        }
                      },
                      "is-practice": "",
                      "course-name": _vm.courseName
                    },
                    on: { "access-prevented": _vm.preventAccess }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "title-container" },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: _vm.lessonLinkWithLLP(
                              practiceLesson.link,
                              _vm.learningPath
                            )
                          }
                        },
                        [
                          _c(
                            "h4",
                            {
                              directives: [
                                {
                                  name: "track",
                                  rawName: "v-track:click",
                                  value: {
                                    axId: "clicked_course_landing_practice",
                                    axType: "button",
                                    axExtra: {
                                      course_id: _vm.courseId,
                                      lesson_id: practiceLesson.quiz_id,
                                      locked: _vm.isLocked
                                    }
                                  },
                                  expression:
                                    "{\n              axId: 'clicked_course_landing_practice',\n              axType: 'button',\n              axExtra: {\n                course_id: courseId,\n                lesson_id: practiceLesson.quiz_id,\n                locked: isLocked,\n              },\n            }",
                                  arg: "click"
                                }
                              ],
                              staticClass: "title",
                              on: { click: _vm.preventIfLocked }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(practiceLesson.name) +
                                  "\n          "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      !_vm.isMobile(_vm.$mq)
                        ? _c("LessonAdmin", {
                            staticClass: "lesson-admin practice",
                            attrs: { lesson: practiceLesson }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLast
        ? _c("div", {
            class: [
              "vertical-line",
              _vm.lesson.user_state,
              {
                "has-practice": _vm.hasPractice,
                "is-recommended": _vm.isRecommended
              }
            ]
          })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }